import React, { forwardRef, FunctionComponent } from 'react';
import SchemaView from '@components/sources/source-view/source-schema/schema-view';
import ErrorsView, { ErrorAssetProps } from './errorsView';
import SchemaEditor, { ISchemaEditProps } from './schemaEditor';

interface SchemaProps extends ISchemaEditProps {
  edit: boolean;
  schemaErrors: Record<string, ErrorAssetProps>;
}
const Schema: FunctionComponent<SchemaProps> = forwardRef((props: SchemaProps, ref) => {
  const {
    edit,
    setMessage,
    setMappingTypeValue,
    mappingSupportTypeVal,
    source,
    destination,
    mappingTypeValue,
    setMappingSupportTypeVal,
    schemaErrors,
    updateSchemaErrors,
    setBottomEditButtonVisible,
    ifUpdate,
    setValid,
  } = props;
  return (
    <>
      <ErrorsView errors={schemaErrors} />
      {edit ? (
        <SchemaEditor
          ref={ref}
          setMessage={setMessage}
          setMappingTypeValue={setMappingTypeValue}
          mappingSupportTypeVal={mappingSupportTypeVal}
          source={source}
          destination={destination}
          mappingTypeValue={mappingTypeValue}
          setMappingSupportTypeVal={setMappingSupportTypeVal}
          setBottomEditButtonVisible={setBottomEditButtonVisible}
          ifUpdate={ifUpdate}
          setValid={setValid}
          updateSchemaErrors={updateSchemaErrors}
        />
      ) : (
        <SchemaView
          source={source}
          setMappingTypeValue={setMappingTypeValue}
          destination={destination}
          setBottomEditButtonVisible={setBottomEditButtonVisible}
          updateSchemaErrors={updateSchemaErrors}
        />
      )}
    </>
  );
});

export default Schema;
